import styled from '@emotion/styled'

const CARD_BG_COLOR = '#f5f5f6'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 0 20px;
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px 16px;
  background-color: ${CARD_BG_COLOR};
  border-radius: 12px;
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e8e8ea;
`
